import { render, staticRenderFns } from "./RemoveReasonDialog.vue?vue&type=template&id=501d77a8&"
import script from "./RemoveReasonDialog.vue?vue&type=script&lang=js&"
export * from "./RemoveReasonDialog.vue?vue&type=script&lang=js&"
import style0 from "./RemoveReasonDialog.vue?vue&type=style&index=0&id=501d77a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports